import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthService } from "./services/auth.service";

/**
 * Dashboard access is a per-consultant permission rather than a group membership, so it
 * is checked here instead of in GroupGuard. Waits for the identity to resolve: entering
 * /dashboard by URL runs the guard while the app is still bootstrapping.
 */
export const dashboardAccessGuard: CanActivateFn = async () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    await auth.whenReady();

    return auth.hasDashboardAccess() || router.parseUrl('/orders');
};
